import { render, staticRenderFns } from "./UpdatePhone.vue?vue&type=template&id=dc0ab2ee&scoped=true"
import script from "./UpdatePhone.vue?vue&type=script&lang=js"
export * from "./UpdatePhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0ab2ee",
  null
  
)

export default component.exports